import { Container, Paper, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Perspectives } from './lead-questionnaire.types';

interface Props {
  perspective?: Perspectives;

  handleShowIntroductionClick(): void;
}

const QuestionnaireWelcome: React.FC<Props> = ({ perspective, handleShowIntroductionClick }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const leadLogo = '/dashboard/images/lead/lead_logo.png';

  return (
    <Container maxWidth={'lg'}>
      <Stack gap={4}>
        <Typography className={classes.title}>
          <Trans i18nKey={'leadQuestionnaireGreeting'}>
            Herzlich Willkommen zum <b>LEaD-Führungsfeedback</b>
          </Trans>
        </Typography>
        <Stack direction={'row'} justifyContent={'center'}>
          <img className={classes.logo} src={leadLogo} alt="Lead Logo" />
        </Stack>
        <Stack gap={2}>
          <Paper className={classes.textContainer} elevation={2} square={true}>
            <Stack gap={2}>
              {perspective === Perspectives.SELF ? (
                <>
                  <Typography className={classes.text}>{t('leadQuestionnaireGreetingSelfPerspectiveText1')}</Typography>
                  <Typography className={classes.text}>
                    <Trans i18nKey={'leadQuestionnaireGreetingSelfPerspectiveText2'}>
                      herzlich Willkommen zum Führungsfeedback <b>„LEaD - Leadership Effectiveness and Development“</b>. Wir freuen uns, dass Sie
                      teilnehmen.
                    </Trans>
                  </Typography>
                  <Typography className={classes.text}>{t('leadQuestionnaireGreetingSelfPerspectiveText3')}</Typography>
                  <Typography className={classes.text}>
                    <Trans i18nKey={'leadQuestionnaireGreetingSelfPerspectiveText4'}>
                      Das Ausfüllen des Fragebogens wird <b>etwa 15-20 Minuten</b> in Anspruch nehmen. Wir möchten Sie bitten, den Fragebogen an einem
                      Stück auszufüllen. Bitte achten Sie darauf, Ihr Browserfenster in jedem Fall geöffnet zu lassen, auch wenn Sie eine Pause
                      einlegen. Auf diese Weise sind kurze zeitliche Unterbrechungen bei der Bearbeitung des Fragebogens möglich.
                    </Trans>
                  </Typography>
                  <Typography className={classes.text}>
                    <Trans i18nKey={'leadQuestionnaireGreetingSelfPerspectiveText5'}>
                      Ihre Antworten und Angaben werden <b>absolut vertraulich</b> behandelt und sind keiner Person außerhalb des Teams von
                      A47-Consulting & SAIA zugänglich.
                    </Trans>
                  </Typography>
                  <Typography className={classes.text}>{t('leadQuestionnaireGreetingSelfPerspectiveText6')}</Typography>
                </>
              ) : (
                <>
                  <Typography className={classes.text}>{t('leadQuestionnaireGreetingOtherPerspectiveText1')}</Typography>
                  <Typography className={classes.text}>
                    <Trans i18nKey={'leadQuestionnaireGreetingOtherPerspectiveText2'}>
                      herzlich Willkommen zum Führungsfeedback <b>„LEaD - Leadership Effectiveness and Development“</b>. Wir freuen uns, dass Sie
                      teilnehmen.
                    </Trans>
                  </Typography>
                  <Typography className={classes.text}>{t('leadQuestionnaireGreetingOtherPerspectiveText3')}</Typography>
                  <Typography className={classes.text}>
                    <Trans i18nKey={'leadQuestionnaireGreetingOtherPerspectiveText4'}>
                      Das Ausfüllen des Fragebogens wird <b>etwa 15-20 Minuten</b> in Anspruch nehmen. Wir möchten Sie bitten, den Fragebogen an einem
                      Stück auszufüllen. Bitte achten Sie darauf, Ihr Browserfenster in jedem Fall geöffnet zu lassen, auch wenn Sie eine Pause
                      einlegen. Auf diese Weise sind kurze zeitliche Unterbrechungen bei der Bearbeitung des Fragebogens möglich.
                    </Trans>
                  </Typography>
                  <Typography className={classes.text}>
                    <Trans i18nKey={'leadQuestionnaireGreetingOtherPerspectiveText5'}>
                      Ihre Antworten und Angaben werden <b>absolut vertraulich und anonym</b> behandelt und sind keiner Person außerhalb des Teams von
                      A47-Consulting & SAIA zugänglich. Es ist auch im Ergebnisbericht für den
                      Feedbackempfänger nicht möglich, Ihre Aussagen mit
                      Ihrer Person in Verbindung zu bringen - es werden ausschließlich aggregierte und gemittelte Ergebnisse berichtet.
                    </Trans>
                  </Typography>
                  <Typography className={classes.text}>{t('leadQuestionnaireGreetingOtherPerspectiveText6')}</Typography>
                </>
              )}
              <Typography className={classes.text}>
                <Trans i18nKey={'leadQuestionnaireGreetingOpenQuestions'}>
                  Bei Fragen zum Befragungsprozess wenden Sie sich bitte an A47 Consulting (
                  <a href="mailto:lead@a47-consulting-team.de">lead@a47-consulting-team.de</a>)
                </Trans>
              </Typography>
              <Typography className={classes.text}>
                <b>{t('leadQuestionnaireThankYouForParticipation')}</b>
              </Typography>
            </Stack>
          </Paper>
          <Stack direction={'row'} justifyContent={'flex-end'}>
            <PaiButton text={t('continue')} size={'large'} action={handleShowIntroductionClick} />
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(32),
    textAlign: 'center',
  },
  logo: {
    width: '500px',
    height: 'auto',
    marginBottom: '16px',
  },
  textContainer: {
    padding: '24px 32px',
    background: 'rgba(0,0,0,0.03)',
  },
  text: {
    fontSize: theme.typography.pxToRem(18),
  },
}));

export default QuestionnaireWelcome;
